var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram21LogoSvgrepoCom1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "instagram-2-1-logo-svgrepo-com_1_",
    "data-name": "instagram-2-1-logo-svgrepo-com (1)",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17.914,
    height: 17.914,
    viewBox: "0 0 17.914 17.914",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.065,
    cy: 0.978,
    r: 1.27,
    gradientTransform: "translate(0)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fa8f21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#d82d7e"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.693,
    cy: 0.946,
    r: 1.117,
    gradientTransform: "translate(0)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#8c3aaa",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c3aaa"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_34579",
    "data-name": "Path 34579",
    d: "M4.543,17.851a6.031,6.031,0,0,1-2.029-.376,3.4,3.4,0,0,1-1.257-.817A3.369,3.369,0,0,1,.44,15.4a6.031,6.031,0,0,1-.376-2.029C.011,12.221,0,11.876,0,8.958S.012,5.7.063,4.543A6.065,6.065,0,0,1,.439,2.514a3.408,3.408,0,0,1,.817-1.257A3.373,3.373,0,0,1,2.513.439,6.031,6.031,0,0,1,4.542.063C5.694.011,6.04,0,8.957,0s3.263.012,4.415.063A6.065,6.065,0,0,1,15.4.439a3.382,3.382,0,0,1,1.257.817,3.384,3.384,0,0,1,.817,1.257,6.031,6.031,0,0,1,.376,2.029c.053,1.153.063,1.5.063,4.415s-.011,3.263-.063,4.415a6.059,6.059,0,0,1-.376,2.029A3.618,3.618,0,0,1,15.4,17.475a6.031,6.031,0,0,1-2.029.376c-1.152.053-1.5.063-4.415.063s-3.263-.01-4.414-.063",
    fill: "url(#radial-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34580",
    "data-name": "Path 34580",
    d: "M4.543,17.851a6.031,6.031,0,0,1-2.029-.376,3.4,3.4,0,0,1-1.257-.817A3.369,3.369,0,0,1,.44,15.4a6.031,6.031,0,0,1-.376-2.029C.011,12.221,0,11.876,0,8.958S.012,5.7.063,4.543A6.065,6.065,0,0,1,.439,2.514a3.408,3.408,0,0,1,.817-1.257A3.373,3.373,0,0,1,2.513.439,6.031,6.031,0,0,1,4.542.063C5.694.011,6.04,0,8.957,0s3.263.012,4.415.063A6.065,6.065,0,0,1,15.4.439a3.382,3.382,0,0,1,1.257.817,3.384,3.384,0,0,1,.817,1.257,6.031,6.031,0,0,1,.376,2.029c.053,1.153.063,1.5.063,4.415s-.011,3.263-.063,4.415a6.059,6.059,0,0,1-.376,2.029A3.618,3.618,0,0,1,15.4,17.475a6.031,6.031,0,0,1-2.029.376c-1.152.053-1.5.063-4.415.063s-3.263-.01-4.414-.063",
    fill: "url(#radial-gradient-2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34581",
    "data-name": "Path 34581",
    d: "M440.287,446.175a2.218,2.218,0,1,1,2.218,2.219,2.218,2.218,0,0,1-2.218-2.219m-1.2,0a3.417,3.417,0,1,0,3.417-3.417,3.417,3.417,0,0,0-3.417,3.417m6.171-3.553a.8.8,0,1,0,.8-.8h0a.8.8,0,0,0-.8.8m-5.443,8.97a3.679,3.679,0,0,1-1.236-.229,2.2,2.2,0,0,1-1.263-1.263,3.675,3.675,0,0,1-.229-1.236c-.032-.7-.039-.912-.039-2.69s.007-1.987.039-2.69a3.7,3.7,0,0,1,.229-1.236,2.2,2.2,0,0,1,1.263-1.263,3.675,3.675,0,0,1,1.236-.229c.7-.032.912-.039,2.689-.039s1.987.007,2.69.039a3.7,3.7,0,0,1,1.236.229,2.2,2.2,0,0,1,1.263,1.263,3.676,3.676,0,0,1,.229,1.236c.032.7.039.912.039,2.69s-.006,1.987-.039,2.69a3.692,3.692,0,0,1-.229,1.236,2.2,2.2,0,0,1-1.263,1.263,3.676,3.676,0,0,1-1.236.229c-.7.032-.912.039-2.69.039s-1.987-.006-2.689-.039m-.055-12.032a4.88,4.88,0,0,0-1.615.309,3.4,3.4,0,0,0-1.947,1.947,4.882,4.882,0,0,0-.309,1.615c-.033.71-.04.936-.04,2.744s.008,2.034.04,2.744a4.882,4.882,0,0,0,.309,1.615,3.4,3.4,0,0,0,1.947,1.947,4.885,4.885,0,0,0,1.615.309c.71.032.936.04,2.744.04s2.034-.008,2.744-.04a4.882,4.882,0,0,0,1.615-.309,3.4,3.4,0,0,0,1.947-1.947,4.868,4.868,0,0,0,.309-1.615c.032-.71.04-.936.04-2.744s-.008-2.034-.04-2.744a4.88,4.88,0,0,0-.309-1.615,3.4,3.4,0,0,0-1.946-1.947,4.874,4.874,0,0,0-1.615-.309c-.71-.032-.936-.04-2.744-.04s-2.034.007-2.744.04",
    transform: "translate(-433.529 -437.18)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram21LogoSvgrepoCom1);
export default __webpack_public_path__ + "static/media/instagram-2-1-logo-svgrepo-com (1).a9b9fff1b9076dafae79ed5ae6b1814b.svg";
export { ForwardRef as ReactComponent };